import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  LogOut,
  User,
  Settings,
  CreditCard,
  Menu
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface UniversalTopBarProps {
  onMenuClick: () => void;
}

const UniversalTopBar: React.FC<UniversalTopBarProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();

  const handleNotificationsClick = () => {
    navigate('/notifications');
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleBillingClick = () => {
    navigate('/billing');
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-white shadow-sm border-b z-40">
      <div className="flex justify-between items-center h-14 md:h-16 px-2 md:px-4 lg:px-2">
        {/* Logo and Menu Button */}
        <div className="flex items-center space-x-3">
          {/* Hamburger Menu - Hidden on desktop, visible on mobile/tablet */}
          <Button
            variant="ghost"
            size="sm"
            className="lg:hidden text-vitl-navy hover:text-vitl-green h-8 w-8 md:h-9 md:w-9 p-0"
            onClick={onMenuClick}
          >
            <Menu className="w-5 h-5 md:w-6 md:h-6" />
          </Button>
          <Link to="/dashboard">
            <img 
              src="/large_logo.png" 
              alt="VITL Logo" 
              className="h-7 md:h-8 object-contain cursor-pointer"
            />
          </Link>
        </div>
        
        {/* User Menu */}
        <div className="flex items-center space-x-3 md:space-x-4 mr-3">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button 
                variant="ghost" 
                className="w-8 h-8 md:w-9 md:h-9 bg-vitl-green rounded-full flex items-center justify-center text-white font-syne font-medium text-sm md:text-base p-0 hover:bg-vitl-green/90 focus:bg-vitl-green/90"
              >
                J
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56 bg-white border border-gray-200 shadow-lg z-50">
              <DropdownMenuItem className="cursor-pointer hover:bg-gray-100 focus:bg-gray-100" onClick={handleProfileClick}>
                <User className="w-4 h-4 mr-2" />
                <span>Profile</span>
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer hover:bg-gray-100 focus:bg-gray-100" onClick={handleBillingClick}>
                <CreditCard className="w-4 h-4 mr-2" />
                <span>Billing</span>
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer hover:bg-gray-100 focus:bg-gray-100">
                <Settings className="w-4 h-4 mr-2" />
                <span>Settings</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem className="cursor-pointer text-red-600 hover:bg-red-50 focus:bg-red-50 focus:text-red-600">
                <LogOut className="w-4 h-4 mr-2" />
                <span>Sign Out</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

export default UniversalTopBar;